<template>
  <b-modal id="agent-modal">
    <template v-slot:modal-header="">
      <h5>الموظف</h5>
    </template>

    <template v-slot:default="">
      <div class="form-group text-right">
        <label class="small">الاسم:</label>
        <input class="form-control" placeholder="الاسم" v-model="agent.name" />
        <div v-if="!agent.name" class="small text-red">الإدخال مطلوب.</div>
      </div>

      <div class="form-group mt-3 text-right">
        <label class="small">رقم الجوال:</label>
        <input
          class="form-control"
          placeholder="رقم الجوال"
          type="text"
          v-model="agent.mobile"
        />
        <div v-if="!agent.mobile" class="small text-red">الإدخال مطلوب.</div>
      </div>

      <!-- <div class="form-group mt-3 text-right">
        <label class="small">البريد الإلكتروني:</label>
        <input
          class="form-control"
          placeholder="البريد الإلكتروني"
          type="email"
          v-model="agent.email"
        />
        <div v-if="!agent.email" class="small text-red">الإدخال مطلوب.</div>
      </div> -->

      <div class="form-group mt-3 text-right">
        <label class="small">عنوان العمل:</label>
        <textarea
          class="form-control"
          placeholder="عنوان العمل"
          v-model="agent.workAddress"
        ></textarea>
        <div v-if="!agent.workAddress" class="small text-red">
          الإدخال مطلوب.
        </div>
      </div>

      <div class="form-group mt-3 text-right">
        <label class="small">رقم الهوية:</label>
        <input
          class="form-control"
          placeholder="رقم الهوية"
          v-model="agent.idNumber"
        />
        <div v-if="!agent.idNumber" class="small text-red">الإدخال مطلوب.</div>
      </div>

      <div class="form-group mt-3 text-right">
        <label class="small">كلمة المرور:</label>
        <input
          class="form-control"
          placeholder="كلمة المرور"
          v-model="agent.password"
          type="password"
        />
        <div v-if="!agent.password && !selectedAgent" class="small text-red">الإدخال مطلوب.</div>
      </div>

      <div class="form-group mt-3 text-right">
        <label class="small">تأكيد كلمة المرور:</label>
        <input
          class="form-control"
          placeholder="تأكيد كلمة المرور"
          v-model="agent.password_confirmation"
          type="password"
        />
        <div v-if="!agent.password_confirmation && !selectedAgent" class="small text-red">الإدخال مطلوب.</div>
      </div>

      <div
        class="pointer d-inline-block mt-3"
        @click="$refs.idCardImage.click()"
      >
        <div class="m-auto">
          <img
            ref="idCardPreview"
            class="id-card-preview m-auto"
            :src="getImage"
            alt=""
          />
        </div>
        <span class="text-muted small">تحديث صورة الهوية</span>
        <input
          ref="idCardImage"
          type="file"
          style="display: none"
          @change="updateImage"
          accept="image/*"
        />
      </div>
    </template>

    <template v-slot:modal-footer="">
      <button type="submit" class="btn btn-primary" @click="submit">حفظ</button>
      <a
        href="#"
        class="text-muted"
        @click="$bvModal.hide('agent-modal')"
        >إغلاق</a
      >
    </template>
  </b-modal>
</template>

<script>
import AgentsMixin from "@/mixins/agents";

export default {
  mixins: [AgentsMixin],

  data() {
    return {
      agent: {
        name: null,
        // email: null,
        mobile: null,
        workAddress: null,
        idNumber: null,
        password: null,
        password_confirmation: null,
        image: {
          link: null
        }
      },
    };
  },

  mounted() {
    this.buildAgent();
  },

  methods: {
    buildAgent() {
      if (this.selectedAgent) {
        // this.agent.name = this.selectedAgent.name;
        // this.agent.email = this.selectedAgent.email;
        // this.agent.mobile = this.selectedAgent.mobile;
        // this.agent.workAddress = this.selectedAgent.workAddress;
        // this.agent.idNumber = this.selectedAgent.idNumber;
        // this.agent.image = this.selectedAgent.image;
        Object.keys(this.agent).forEach((k) => (this.agent[k] = this.selectedAgent[k]));
        if (this.selectedAgent.image) {
          this.agent.image.link = this.selectedAgent.image.link
        }

      } else {
        Object.keys(this.agent).forEach((k) => (this.agent[k] = null));
      }
    },
    submit() {
      this.saveAgent(this.agent).then((res) => {
        if (res.success) {
          // this.showSwal(res)
          if (this.$refs.idCardImage.files[0]) {
            this.saveAgentImage(this.$refs.idCardImage.files[0]).then(
              (res2) => {
                if (res2.success) this.$bvModal.hide("agent-modal");
              }
            );
          } else {
            this.showSwal(res);
            this.$bvModal.hide("agent-modal");
          }
        } else {
          this.showSwal(res);
        }
      });
    },

    updateImage(e) {
      this.$refs.idCardPreview.src = URL.createObjectURL(e.target.files[0]);
    },
  },

  computed: {
    getImage () {
      return this.agent.image ? this.agent.image.link : require('@/assets/images/image-placeholder.png')
    }
  },

  watch: {
    selectedAgent() {
      this.buildAgent();
    },
  },
};
</script>